export const CREATE_TEAM_PLAN = 'CREATE_TEAM_PLAN';
export const LEAVE_TEAM_PLAN = 'LEAVE_TEAM_PLAN';
export const UPDATE_TEAM_PLAN = 'UPDATE_TEAM_PLAN';
export const UPDATE_TEAM_PLAN_RESP = 'UPDATE_TEAM_PLAN_RESP';
export const FETCH_TEAM_PLAN = 'FETCH_TEAM_PLAN';
export const FETCH_TEAM_PLAN_RESP = 'FETCH_TEAM_PLAN_RESP';
export const FETCH_USER_BY_EMAIL = 'FETCH_USER_BY_EMAIL';
export const FETCH_USER_BY_EMAIL_RESP = 'FETCH_USER_BY_EMAIL_RESP';
